import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import Portal from './Portal';

const CLASS_PREFIX = 'modal';

export const Modal = (props) => {
  const { onClose, children, unmountOnClose = true, isOpen } = props;

  const closeRef = useRef(null);

  const handleClose = () => {
    if (onClose && typeof onClose === 'function') {
      onClose();
    }
  };

  const handleKeyPress = (event) => {
    if (event.keyCode === 27) {
      handleClose();
    }
  };

  const shouldRender = isOpen || !unmountOnClose;

  useEffect(() => {
    if (!isOpen) return;
    closeRef?.current?.focus();
    document.addEventListener('keydown', handleKeyPress);

    return () => {
      document.removeEventListener('keydown', handleKeyPress);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isOpen]);

  if (!shouldRender) return null;

  return (
    <Portal>
      <div className={`${CLASS_PREFIX}${isOpen ? ` ${CLASS_PREFIX}--open` : ''}`}>
        <button
          className={`${CLASS_PREFIX}__close`}
          onClick={handleClose}
          ref={closeRef}
        >
          <span className='icon icon-outlined'>close</span>
        </button>
        <div className={`${CLASS_PREFIX}__content`}>{children}</div>
      </div>
    </Portal>
  );
};

Modal.propTypes = {
  onClose: PropTypes.func.isRequired,
  children: PropTypes.node.isRequired,
  unmountOnClose: PropTypes.bool,
  isOpen: PropTypes.bool.isRequired,
};
